import { useSortable } from '@dnd-kit/sortable';
import { Form } from 'antd';
import { Colors, IcArrange, IcClose, Row, Text } from 'basic-ui-lib';
import BaseTimePicker from 'basic-ui-lib/components/Input/InputTime';
import { RenderMedia } from 'basic-ui-lib/components/screen/RenderMedia';
import dayjs from 'dayjs';
import { IContentItem } from 'modules/playlist/interfaces/api';
import styled from 'styled-components';
import { FormValues } from '../PlaylistForm';

interface PlaylistItemProps {
  item: IContentItem;
  id: number;
  onRemove: () => void;
  ids: number;
}

const PlaylistItem = ({ item, id, onRemove, ids }: PlaylistItemProps) => {
  const form = Form.useFormInstance<FormValues>();

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const handleChangeValue = (value: dayjs.Dayjs | null) => {
    const currentContentItems = form.getFieldValue('contentItems') || [];
    const newContentItems = [...currentContentItems];
    if (value) {
      const durationInSeconds = value.hour() * 3600 + value.minute() * 60 + value.second();
      newContentItems[ids] = {
        ...newContentItems[ids],
        duration: durationInSeconds,
      };
      form.setFieldsValue({ contentItems: newContentItems });
    }
  };

  return (
    <Container
      ref={setNodeRef}
      style={{
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition,
        opacity: isDragging ? 0.5 : 1,
      }}
    >
      <Row alignItems='center' gap={16}>
        <button {...attributes} {...listeners} onClick={(e) => e.stopPropagation()} type='button'>
          <IcArrange width={16} height={16} fill={Colors.neutral.bg[7]} />
        </button>
        <MediaContent>{RenderMedia({
          url: item.url,
          type: item.type as any,
          name: item.name || '',
        }, 4)}</MediaContent>
        <Text className='name-text' content_2 medium ellipsis lineClamp={2} left>
          {item.name}
        </Text>
      </Row>
      <BaseTimePicker
        needConfirm={false}
        showNow={false}
        suffixIcon={null}
        allowClear={false}
        className='styled-time-picker'
        value={typeof item.duration === 'number' ? dayjs().startOf('day').add(item.duration, 'second') : undefined}
        onChange={(value) => handleChangeValue(value)}
      />

      <Text>{item.type.toUpperCase()}</Text>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        type='button'
      >
        <IcClose width={24} height={24} fill={Colors.neutral.bg[7]} />
      </button>
    </Container>
  );
};

export default PlaylistItem;

const Container = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 0.5fr;
  padding: 8px 24px;
  align-items: center;
  border: 1px solid ${Colors.neutral.border[1]};
  border-radius: 8px;
  background-color: ${Colors.neutral.bg[1]};
  button {
    text-align: end;
  }

  .name-text {
    flex: 1;
  }

  .styled-time-picker {
    width: fit-content !important;
    padding: 8px 10px;
  }
  .styled-time-picker .ant-picker-input > input {
    width: 70px;
    text-align: center;
  }
`;

const MediaContent = styled.div`
  width: 120px;
  min-width: 120px;
  height: 68px;
  position: relative;
`;
